module.exports = __webpack_public_path__ + "img/lastBridge-3018-10-13.93b7036d.jpg";